var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "1.2 .5 17.6 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "checkInCircle",
    "aria-label": "avsjekket",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9,
    r: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9638 17C14.3621 17 17.9276 13.4183 17.9276 9C17.9276 4.58172 14.3621 1 9.9638 1C5.56552 1 2 4.58172 2 9C2 13.4183 5.56552 17 9.9638 17ZM2 9C2 4.6 5.58371 1 9.9638 1C14.3439 1 17.9276 4.6 17.9276 9C17.9276 13.4 14.3439 17 9.9638 17C5.58371 17 2 13.4 2 9ZM14.9832 6.3578L8.37104 13L4.948 9.5614C4.63894 9.25094 4.63894 8.74906 4.948 8.4386C5.25597 8.12923 5.75566 8.12571 6.06795 8.43071L8.37104 10.68L13.8232 5.20307C14.1509 4.87387 14.6866 4.88311 15.0027 5.22339C15.3019 5.54542 15.2933 6.04628 14.9832 6.3578Z",
    fill: "#8BBE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInCircle);
export default __webpack_public_path__ + "static/media/checkInCircle.2a211ae2.svg";
export { ForwardRef as ReactComponent };